import { createContext, use, type ReactNode } from 'react';
import { Icon, type IconName } from '@tutero/ui';

/** The open page's glyph: its row's in the nav, set by the shell where it draws the page. */
export const PageIcon = createContext<IconName | null>(null);

/**
 * A page's heading: its name beside the glyph the nav lists it under, so the two read as one
 * thing. A tool names only the words; the glyph comes from its manifest. `icon` is for the page
 * of tabs, which is drawn outside any one tool's surface.
 */
export function PageTitle({
  icon,
  children,
}: {
  icon?: IconName;
  children: ReactNode;
}) {
  const inherited = use(PageIcon);
  const name = icon ?? inherited;
  return (
    <h1 className="text-headline-4 flex items-center gap-2">
      {/* `classic`, as the nav's row. Decorative: the words are the heading's name. */}
      {name ? <Icon name={name} set="classic" size={24} /> : null}
      {children}
    </h1>
  );
}
